import React, { forwardRef } from "react";
import styles from "./buttonNextLevel.module.css";

const ButtonNextLevel = forwardRef((props, ref) => {
  return (
    <div className={styles.body}>
      <button ref={ref} className={styles.button1} onClick={props.onClick}>
        {props.icon ? (
          <div className={styles.icon}>{props.icon}</div>
        ) : (
          <div className={styles.air}></div>
        )}
        <div>{props.children}</div>
        {props.Nextlevel - 1 
        !== 0 && (
          <div className={styles.level}>ระดับที่ {props.Nextlevel}</div>
        )}
      </button>
    </div>
  );
});

export default ButtonNextLevel;
